var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.05 1.375c3.68 0 6.676 2.995 6.676 6.673 0 1.57-.568 3.001-1.483 4.143l7.382 7.38-1.043 1.054-7.388-7.386c-1.142.915-2.573 1.483-4.144 1.483-3.68 0-6.675-2.995-6.675-6.674 0-3.678 2.996-6.673 6.675-6.673Zm0 1.483a5.183 5.183 0 0 0-5.192 5.19A5.183 5.183 0 0 0 8.05 13.24a5.183 5.183 0 0 0 5.193-5.19A5.183 5.183 0 0 0 8.05 2.857Z",
  fill: "#CCC"
})));
export default SvgSearch;